// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const LOCALHOST = 'http://localhost';
const HOST = 'https://us-east1-perpetue-dev.cloudfunctions.net';
//const HOST_PATH = '/perpetue-me/southamerica-east1';

export const environment = {
  production: false,
  API_URL: HOST,
  API_URL_DOC: `${HOST}/documentos`,
  API_URL_USER: `${HOST}/user`,
  API_URL_PDF: `${HOST}/pdf`,  
  API_URL_MAIL: `${HOST}/mail`,
  API_URL_STORAGE: `${LOCALHOST}/storage`,
  API_URL_PAGAMENTO: `${LOCALHOST}/pagamento`,
  API_URL_CONTRATO: `${LOCALHOST}:3000`,
  API_URL_CRIPTO: `${LOCALHOST}:8080`,
  firebaseConfig : {
    apiKey: "AIzaSyCRG1YgpubpmccwPtKix33LVykvhXGbWGk",
    authDomain: "perpetue-dev.firebaseapp.com",
    projectId: "perpetue-dev",
    storageBucket: "perpetue-dev.appspot.com",
    messagingSenderId: "723148403660",
    appId: "1:723148403660:web:12c36b876f217fb1172369"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
